import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDd-gXhFRB66aK-gEnBbjanOwPP0DCjVvY",
  authDomain: "truckloading-16846.firebaseapp.com",
  projectId: "truckloading-16846",
  storageBucket: "truckloading-16846.appspot.com",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
